import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';

export class ColumnsSetsListClass extends Component {

    handleSelectSet(setId) {
        if (this.props.onSelectColumnSet) {
            this.props.onSelectColumnSet(setId);
        }
    }

    handleDeleteSet(event, setId) {
        event.preventDefault();
        event.stopPropagation();
        if (this.props.onDeleteColumnSet) {
            this.props.onDeleteColumnSet(setId);
        }
    }

    render() {
        const { t, columnsSets, activeColumnsSetId, columnsSetsObject } = this.props;
        
        if (!columnsSets || columnsSets.length === 0) {
            return <p className="header-menu-message">{t('columns_sets_list.no_column_sets_saved_yet')}</p>;
        }

        // columnsSets es un array de IDs, columnsSetsObject es el objeto completo con estructura {id: {id, name, columns}}
        // Filtrar el set "UNNAMED_UNSAVED_COLUMNS_SET" para no mostrarlo
        const setsArray = columnsSets.filter(setId => {
            const set = columnsSetsObject && columnsSetsObject[setId];
            return set && set.name !== 'UNNAMED_UNSAVED_COLUMNS_SET';
        });
        const setsObject = columnsSetsObject || {};

        return (
            <ul>
                {setsArray.map((setId) => {
                    const set = setsObject[setId];
                    if (!set) return null;
                    
                    // Usar activeColumnsSetId para determinar si el set está activo por ID
                    const isActive = String(activeColumnsSetId) === String(setId);
                    
                    return (
                        <li key={setId}>
                            <button
                                className="header-menu-list-button"
                                onClick={(e) => {
                                    // Si el click fue en el botón de eliminar, no hacer nada aquí
                                    if (e.target.closest('.header-menu-list-button-delete')) {
                                        return;
                                    }
                                    e.preventDefault();
                                    this.handleSelectSet(setId);
                                }}
                            >
                                <span>
                                    {set.name || setId}
                                    {isActive && (
                                        <FaIcon
                                            iconName="check"
                                            style={{
                                                marginLeft: '0.5rem',
                                                color: '#28a745',
                                                fontSize: '1em'
                                            }}
                                        />
                                    )}
                                    {set.portal_assignments_count > 0 && (
                                        <span
                                            className="columns-set-portal-badge"
                                            title={t(
                                                set.portal_assignments_count === 1
                                                    ? 'columns_sets_list.assigned_to_portals_one'
                                                    : 'columns_sets_list.assigned_to_portals_other',
                                                { count: set.portal_assignments_count }
                                            )}
                                        >
                                            <FaIcon iconName="user-group" />
                                            {' '}{set.portal_assignments_count}
                                        </span>
                                    )}
                                </span>
                                <span
                                    className="header-menu-list-button-delete"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.handleDeleteSet(e, setId);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            this.handleDeleteSet(e, setId);
                                        }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                    title={t('columns_sets_list.delete_set', 'Borrar set')}
                                >
                                    <FaIcon iconName="trash" />
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

export const ColumnsSetsList = withTranslation()(ColumnsSetsListClass);
export default ColumnsSetsList;